import openSocket from 'socket.io-client';
const socket = openSocket('https://numbers.inspectron.ch/');

function getNumber() {
    socket.on('number2', (data) => {
        console.log(data)
    })
}

function sendNumber(nr) { 
    socket.emit('number', nr)
}

function sendReset(sm) {
    socket.emit("resetAll", sm)
}

function getReset() {
    socket.on("resetAll2", (data) => {
        console.log(data + "hehehe")
        localStorage.removeItem("numbers");
        //this.forceUpdate();
      })
}

export {
    getNumber,
    sendNumber,
    sendReset,
    getReset
};


// WEBPACK FOOTER //
// ./src/components/api.js